import React, { useState } from 'react';
import './App.css';
import StartMenu from './Footer/StartMenu';
import FooterMenu from './Footer/FooterMenu';
import Item from './DesktopItems/Item';
import Portfolio from './DesktopItems/Portfolio';
import 'xp.css';
import WebsiteHeader from './DesktopItems/WebsiteHeader';



function App() {
  const [portfolioSection, setPortfolioSection] = useState('');

  const portfolioUrl = portfolioSection
    ? `C:/Documents and Settings/Pirasana/Desktop/Portfolio.html/${portfolioSection}`
    : "C:/Documents and Settings/Pirasana/Desktop/Portfolio.html";

  const [startMenuVisible, setStartMenuVisible] = useState(false);
  const [windows, setWindows] = useState([
    { title: 'Portfolio.html', icon: 'xp_images/Default.png', minimized: false, zIndex: 2 },
  ]);

  const handleMinimize = (title) => {
    setWindows((prev) =>
      prev.map((window) =>
        window.title === title ? { ...window, minimized: true } : window
      )
    );
  };
  
  const handleOpen = (title, icon) => {
    setWindows((prev) => {
      if (!prev.some((window) => window.title === title)) {
        return [...prev, { title, icon, minimized: false }];
      }
      return prev.map((window) =>
        window.title === title ? { ...window, minimized: false } : window
      );
    });
  };
  
  const restoreWindow = (title) => {
    setWindows((prev) =>
      prev.map((window) =>
        window.title === title ? { ...window, minimized: false } : window
      )
    );
    bringToFront(title); // Bring the window to the front
  };

  const handleClose = (title) => {
    setWindows((prev) => prev.filter((window) => window.title !== title));
  };


  const toggleStartMenu = () => {
    setStartMenuVisible(!startMenuVisible);
  };

  const bringToFront = (title) => {
    setWindows((prev) => {
      const maxZIndex = Math.max(...prev.map((window) => window.zIndex || 0), 0); // Get the highest zIndex
      return prev.map((window) =>
        window.title === title ? { ...window, zIndex: maxZIndex + 1 } : window
      );
    });
  };


    return (
      <div
        style={{
          position: 'fixed', // Fix the background to the viewport
          top: 0,
          left: 0,
          backgroundImage: `url('./images/windowsxp.jpeg')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          height: '100vh',
          width: '100vw',
          zIndex: -1, // Ensure it stays behind all other content
        }}
      >
        <nav style={{ position: 'absolute', top: '10px', left: '10px' }}>
        </nav>
        <header className="header center">
          <div style={{ width: 300 }} className="window">
            <div className="title-bar">
              <div className="title-bar-text">Portfolio</div>
              <div className="title-bar-controls">
                <button aria-label="Minimize" />
                <button aria-label="Maximize" />
                <button aria-label="Close" />
              </div>
            </div>
    
            <div className="window-body">
              <p style={{ textAlign: 'center' }}>In the works</p>
              <div className="field-row" style={{ justifyContent: 'center' }}>
                <progress></progress>
              </div>
            </div>
          </div>
        </header>
        <main>
          {/* Item for My Resume (iframe-based content) */}
          <Item
            title="My Resume"
            icon="xp_images/Default.png"
            content="/ItemsContent/Pirasana_resume.pdf"
            isIframe={true} // Render as iframe
            handleMinimize={handleMinimize} // Pass the minimize function
            handleOpen={handleOpen} // Pass the open function
            windows={windows} // Pass the windows state
            handleClose={handleClose}
            bringToFront={bringToFront} // Pass the bringToFront function
          />
    
          {/* Item for Portfolio (React-based content) */}
          <Item
            title="Portfolio.html"
            icon="xp_images/Default.png"
            content={
              <Portfolio onSectionChange= {setPortfolioSection} />
            } // Pass React component as content
            isIframe={false} // Render as React component
            header={<WebsiteHeader url={portfolioUrl} />} // Pass the header as a prop
            handleMinimize={handleMinimize} // Pass the minimize function
            handleOpen={handleOpen} // Pass the open function
            windows={windows} // Pass the windows state
            handleClose={handleClose}
            bringToFront={bringToFront} // Pass the bringToFront function
          />

          {/* Item for Internet Explorer */}
          <Item
            title="Internet Explorer"
            icon="xp_images/Internet_Explorer.png"
            content="https://www.google.com/webhp?igu=1" // Example URL
            isIframe={true} // Render as iframe
            header={<WebsiteHeader url={"https://www.google.ca"} />}
            handleMinimize={handleMinimize} // Pass the minimize function
            handleOpen={handleOpen} // Pass the open function
            windows={windows} // Pass the windows state
            handleClose={handleClose}
            bringToFront={bringToFront} // Pass the bringToFront function
          />
        </main>
        <div>{startMenuVisible && <StartMenu />}</div>
        <FooterMenu
          toggleStartMenu={toggleStartMenu}
          onRestore={restoreWindow}
          windows={windows}
        />
      </div>
    );
}


export default App;